import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import axios from "axios";
import classes from "./franchiseForm.module.css";
import InputField from "../../containers/inputField/inputField";
import { sixYardAxios } from '../../../sixYardAxios';
import PromptMessage from '../../containers/promptMessage/promptMessage';

const Form = (props) => {
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [loading, setLoading] = useState(false);
    const [countries, setCountries] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState("");
    
    // Get language from Redux props instead of localStorage
    const currentLang = props.selectedLanguage;
    const isEnglish = currentLang === 1;
    
    const [controls, setControls] = useState({
        fullName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: isEnglish ? "Enter name" : "أدخل الاسم",
            },
            value: "",
            validation: {
                required: true,
            },
            label: isEnglish ? "Full Name" : "الاسم الكامل",
            valid: false,
            touched: false
        },
        email: {
            elementType: "input",
            elementConfig: {
                type: "email",
                placeholder: isEnglish ? "Enter email" : "أدخل البريد الإلكتروني",
            },
            value: "",
            label: isEnglish ? "Email" : "البريد الإلكتروني",
            validation: {
                required: true,
                isEmail: true
            },
            valid: false,
            touched: false
        },
        phone: {
            elementType: "input",
            elementConfig: {
                type: "phone",
                placeholder: "07xxxxxxxx",
                options: []
            },
            value: "",
            valueName: "phone_number",
            validation: {
                required: true,
                isNumeric: true
            },
            label: isEnglish ? "Phone Number" : "رقم الهاتف",
            valid: false,
            touched: false
        },
        yourBusiness: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: isEnglish ? "Enter business" : "أدخل نشاطك التجاري",
            },
            value: "",
            validation: {
                required: true,
            },
            label: isEnglish ? "Your business" : "نشاطك التجاري",
            valid: false,
            touched: false
        },
        countryOfFranchisee: {
            elementType: "select",
            elementConfig: {
                type: "text",
                placeholder: isEnglish ? "Select country" : "اختر البلد",
                options: []
            },
            value: "",
            validation: {
                required: true,
            },
            label: isEnglish ? "Country Of Franchisee" : "بلد الامتياز",
            valid: false,
            touched: false
        },
        countryOfResidence: {
            elementType: "select",
            elementConfig: {
                type: "text",
                placeholder: isEnglish ? "Select country" : "اختر البلد",
                options: []
            },
            value: "",
            validation: {
                required: true,
            },
            label: isEnglish ? "Country Of Residence" : "بلد الإقامة",
            valid: false,
            touched: false
        },
        cityOfResidence: {
            elementType: "select",
            elementConfig: {
                type: "text",
                placeholder: isEnglish ? "Select city" : "اختر المدينة",
                options: []
            },
            value: "",
            validation: {
                required: true,
            },
            label: isEnglish ? "City Of Residence" : "مدينة الإقامة",
            valid: false,
            touched: false
        },
        tellUsMore: {
            elementType: "textarea",
            elementConfig: {
                type: "textarea",
                placeholder: isEnglish 
                    ? "Tell us what would be a good fit to become a 6 Yard Franchisee"
                    : "أخبرنا ما الذي يجعلك مناسباً لتكون صاحب امتياز 6 يارد",
            },
            value: "",
            label: isEnglish ? "Tell Us More" : "أخبرنا المزيد",
            valid: false,
            touched: false,
        },
    });
    
    // Update form controls when language changes
    useEffect(() => {
        const updatedControls = { ...controls };
        
        // Update each control's language-specific properties
        Object.keys(updatedControls).forEach(key => {
            const control = updatedControls[key];
            
            // Update placeholder and label based on language
            if (control.elementConfig) {
                if (key === 'fullName') {
                    control.elementConfig.placeholder = isEnglish ? "Enter name" : "أدخل الاسم";
                    control.label = isEnglish ? "Full Name" : "الاسم الكامل";
                } else if (key === 'email') {
                    control.elementConfig.placeholder = isEnglish ? "Enter email" : "أدخل البريد الإلكتروني";
                    control.label = isEnglish ? "Email" : "البريد الإلكتروني";
                } else if (key === 'phone') {
                    control.label = isEnglish ? "Phone Number" : "رقم الهاتف";
                } else if (key === 'yourBusiness') {
                    control.elementConfig.placeholder = isEnglish ? "Enter business" : "أدخل نشاطك التجاري";
                    control.label = isEnglish ? "Your business" : "نشاطك التجاري";
                } else if (key === 'countryOfFranchisee') {
                    control.elementConfig.placeholder = isEnglish ? "Select country" : "اختر البلد";
                    control.label = isEnglish ? "Country Of Franchisee" : "بلد الامتياز";
                } else if (key === 'countryOfResidence') {
                    control.elementConfig.placeholder = isEnglish ? "Select country" : "اختر البلد";
                    control.label = isEnglish ? "Country Of Residence" : "بلد الإقامة";
                } else if (key === 'cityOfResidence') {
                    control.elementConfig.placeholder = isEnglish ? "Select city" : "اختر المدينة";
                    control.label = isEnglish ? "City Of Residence" : "مدينة الإقامة";
                } else if (key === 'tellUsMore') {
                    control.elementConfig.placeholder = isEnglish 
                        ? "Tell us what would be a good fit to become a 6 Yard Franchisee"
                        : "أخبرنا ما الذي يجعلك مناسباً لتكون صاحب امتياز 6 يارد";
                    control.label = isEnglish ? "Tell Us More" : "أخبرنا المزيد";
                }
            }
        });
        
        setControls(updatedControls);
    }, [props.selectedLanguage]);
    
    useEffect(() => {
        fetchCountries();
    }, []);
    
    const fetchCountries = async () => {
        try {
            const response = await axios.get("https://countriesnow.space/api/v0.1/countries");
            const countryOptions = response.data.data
                .map(country => ({
                    value: country.country === "Israel" ? "Palestine" : country.country,
                    displayValue: country.country === "Israel" ? "Palestine" : country.country,
                }))
                // Filter out potential duplicates if "Palestine" already exists after replacement
                .filter((country, index, self) => 
                    index === self.findIndex((c) => (
                        c.value === country.value
                    ))
                )
                .sort((a, b) => a.displayValue.localeCompare(b.displayValue)); // Sort alphabetically
            updateControlOptions("countryOfResidence", countryOptions);
            updateControlOptions("countryOfFranchisee", countryOptions);
            setCountries(response.data.data); // Note: This still holds the original data
        } catch (error) {
            console.error("Failed to fetch countries:", error);
        }
    };
    
    const fetchCities = async (country) => {
        try {
            const response = await axios.post("https://countriesnow.space/api/v0.1/countries/cities", {
                country: country,
            });
            const cityOptions = response.data.data
                .map(city => ({
                    value: city,
                    displayValue: city,
                }))
                .sort((a, b) => a.displayValue.localeCompare(b.displayValue)); // Sort alphabetically
            updateControlOptions("cityOfResidence", cityOptions);
            setCities(response.data.data);
        } catch (error) {
            console.error("Failed to fetch cities:", error);
        }
    };
    
    const updateControlOptions = (controlName, options) => {
        setControls((prevControls) => ({
            ...prevControls,
            [controlName]: {
                ...prevControls[controlName],
                elementConfig: {
                    ...prevControls[controlName].elementConfig,
                    options: options,
                },
            },
        }));
    };
    
    const formElementsArray = [];
    for (let key in controls) {
        formElementsArray.push({
            id: key,
            config: controls[key]
        });
    }
    
    const form = formElementsArray.map((formElement, i) => (
        <div key={i} className={classes.FormGroup}>
            <InputField
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                withRemove={false}
                label={formElement.config.label}
                changed={event => inputChangedHandler(event, formElement.id)}
            />
        </div>
    ));
    
    const checkValidity = ((value, rules) => {
        let isValid = true;
        if (!rules) {
            return true;
        }

        if (rules.required) {
            value = typeof value === 'string' ? value.trim() : value;
            isValid = value !== "" && isValid;
        }

        if (rules.isEmail) {
            const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            isValid = pattern.test(value) && isValid;
        }

        if (rules.isNumeric) {
            const pattern = /^\d+$/;
            isValid = pattern.test(value) && isValid;
        }

        return isValid;
    })
    
    const inputChangedHandler = (event, controlName) => {
        const value = controlName === 'phone' ? event : event.target.value;
        // If country is selected, fetch cities
        if (controlName === "countryOfResidence") {
            setSelectedCountry(value);
            fetchCities(value);
        }
        const updatedControls = {
            ...controls,
            [controlName]: {
                ...controls[controlName],
                value,
                valid: checkValidity(value, controls[controlName].validation),
                touched: true
            }
        };
        setControls(updatedControls);
    };
    
    const clearControls = () => {
        const updatedControls = {
            ...controls
        };
        for (let key in controls) {
            updatedControls[key] = {
                ...controls[key],
                value: "",
                valid: false,
                touched: false
            };
        }
        setControls(updatedControls);
    };
    
    const submitHandler = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const formData = {
                full_name: controls.fullName.value,
                email: controls.email.value,
                phone_number: {
                    country_code: controls.phone.value.dialCode,
                    number: controls.phone.value.number
                },
                business_name: controls.yourBusiness.value,
                country_of_franchise: controls.countryOfFranchisee.value,
                country_of_residence: controls.countryOfResidence.value,
                city_of_residence: controls.cityOfResidence.value,
                additional_info: controls.tellUsMore.value,
                terms_accepted: isTermsChecked,
                lang: props.selectedLanguage // Add language parameter to API request if needed
            }
            const response = await sixYardAxios.post('/franchise', formData);
            if (response.data.data) {
                clearControls();
                setSuccess(response.data.message);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <form className={classes.Container} onSubmit={(e) => submitHandler(e)}>
            {form}
            <p className={classes.Prompt}>
                {isEnglish 
                    ? "Please read and agree to our "
                    : "يرجى قراءة والموافقة على "}
                <a href="/privacy-policy" target='_blank' className={classes.Link}>
                    {isEnglish 
                        ? "Privacy Policy "
                        : "سياسة الخصوصية "}
                </a>
                {isEnglish ? "and " : "و "}
                <a href="/terms-and-conditions" target='_blank' className={classes.Link}>
                    {isEnglish ? "Terms" : "الشروط"}
                </a>
            </p>
            <div className={classes.CheckBox}>
                <input type="checkbox" onClick={() => setIsTermsChecked(!isTermsChecked)} />
                <label className={classes.Label}>
                    {isEnglish 
                        ? "I have read and agreed to terms and conditions and privacy policy"
                        : "لقد قرأت ووافقت على الشروط والأحكام وسياسة الخصوصية"}
                </label>
            </div>
            <div>
                <button type="submit" 
                    className={[classes.submitButton, !isTermsChecked && classes.Disabled].join(" ")}
                    disabled={!isTermsChecked}
                >
                    {isEnglish ? "SUBMIT" : "إرسال"}
                    <img
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/b4d5bcaf1ebb966f9c466b88bc4db272a664766c03afdc1eeb10bad706c68a4a?placeholderIfAbsent=true&apiKey=55c20a0273674f7297318d8ed49e9ee9"
                        alt=""
                        className={classes.submitIcon}
                    />
                </button>
            </div>
            {error && <PromptMessage 
                message={error} 
                status={isEnglish ? 'Oops' : 'عفواً'} 
                button={isEnglish ? 'CLOSE' : 'إغلاق'} 
                click={() => setError(false)} 
            />}
            {success && <PromptMessage 
                message={success} 
                status={isEnglish ? 'CONGRATULATIONS' : 'تهانينا'} 
                successMessage 
                button={isEnglish ? 'CLOSE' : 'إغلاق'} 
                click={() => setSuccess(false)} 
            />}
        </form>
    )
}

// Connect to Redux to get language state
const mapStateToProps = state => ({
    selectedLanguage: state.home.selected_language
});

export default connect(mapStateToProps)(Form);